module.exports = "/_next/static/images/CompleteDataCollected-0619bb4857cf765eadf8c5e7f78ce62b.png";